export default {
      id: "message-bubble-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#message-bubble",
      toString: function () {
        return this.url;
      }
    }